
<template>
  <div class="el-select custom-el-select" :class="[selectSize ? 'el-select--' + selectSize : '']" @click.stop="toggleMenu" v-clickoutside="handleClose">
    <div :class="['el-select__tags',selectDisabled?'custom-disabled':'']" v-if="multiple" ref="tags" :style="{ 'max-width': inputWidth - 32 + 'px', width: '100%' }">
      <span v-if="collapseTags && selected.length">
        <el-tag :closable="!selectDisabled" :size="collapseTagSize" :hit="selected[0].hitState" type="info" @close="deleteTag($event, selected[0])" disable-transitions>
          <span class="el-select__tags-text">{{ selected[0].currentLabel }}</span>
        </el-tag>
        <el-tag v-if="selected.length > 1" :closable="false" :size="collapseTagSize" type="info" disable-transitions>
          <span class="el-select__tags-text">+ {{ selected.length - 1 }}</span>
        </el-tag>
      </span>
      <transition-group @after-leave="resetInputHeight" v-if="!collapseTags">
        <el-tag v-for="(item,idx) in selected" :key="getValueKey(item)" :closable="!selectDisabled" :size="collapseTagSize" :hit="item.hitState" type="info" @close="deleteTag($event, item)" disable-transitions>
          <span v-if="selectDisabled">
            <template v-if="item.value.value==otherValue">其它<span class="line" v-if="item.value.remark">|</span>{{item.value.remark}}</template>
            <template v-if="item.value.value!=otherValue">{{ item.value.text }}</template>
            <template v-if="idx!==(selected.length-1)">/</template>
          </span>
          <span v-if="!selectDisabled" class="el-select__tags-text">
            <template v-if="item.value.value==otherValue">
              <div class="other-remark-box">其它<div class="line">|</div><input class="txt-remark" placeholder="请输入备注" maxlength="32" v-model="item.value.remark" type="text" @click.stop="notAnything" @focus.stop="notAnything" /></div>
            </template>
            <template v-else>{{ item.value.text }}</template>
          </span>
        </el-tag>
      </transition-group>

      <input type="text" class="el-select__input" :class="[selectSize ? `is-${ selectSize }` : '']" :disabled="selectDisabled" :autocomplete="autoComplete || autocomplete" @focus="handleFocus" @blur="softFocus = false" @keyup="managePlaceholder" @keydown="resetInputState" @keydown.down.prevent="handleNavigate('next')" @keydown.up.prevent="handleNavigate('prev')" @keydown.enter.prevent="selectOption" @keydown.esc.stop.prevent="visible = false" @keydown.delete="deletePrevTag" @keydown.tab="visible = false" @compositionstart="handleComposition" @compositionupdate="handleComposition" @compositionend="handleComposition" v-model="query" @input="debouncedQueryChange" v-if="filterable" :style="{ 'flex-grow': '1', width: inputLength / (inputWidth - 32) + '%', 'max-width': inputWidth - 42 + 'px' }" ref="input">
    </div>
    <el-input ref="reference" v-model="selectedLabel" type="text" :placeholder="currentPlaceholder" :name="name" :id="id" :autocomplete="autoComplete || autocomplete" :size="selectSize" :disabled="selectDisabled" :readonly="readonly" :validate-event="false" :class="{ 'is-focus': visible }" :tabindex="(multiple && filterable) ? '-1' : null" @focus="handleFocus" @blur="handleBlur" @input="debouncedOnInputChange" @keydown.native.down.stop.prevent="handleNavigate('next')" @keydown.native.up.stop.prevent="handleNavigate('prev')" @keydown.native.enter.prevent="selectOption" @keydown.native.esc.stop.prevent="visible = false" @keydown.native.tab="visible = false" @compositionstart="handleComposition" @compositionupdate="handleComposition" @compositionend="handleComposition" @mouseenter.native="inputHovering = true" @mouseleave.native="inputHovering = false">
      <template slot="prefix" v-if="$slots.prefix">
        <slot name="prefix"></slot>
      </template>
      <template slot="suffix">
        <i v-show="!showClose" :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass]"></i>
        <i v-if="showClose" class="el-select__caret el-input__icon el-icon-close" @click="handleClearClick"></i>
      </template>
    </el-input>
    <transition name="el-zoom-in-top" @before-enter="handleMenuEnter" @after-leave="doDestroy">
      <el-select-menu ref="popper" :append-to-body="popperAppendToBody" v-show="visible && emptyText !== false">
        <el-scrollbar tag="ul" wrap-class="el-select-dropdown__wrap" view-class="el-select-dropdown__list" ref="scrollbar" :class="{ 'is-empty': !allowCreate && query && filteredOptionsCount === 0 }" v-show="options.length > 0 && !loading">
          <el-option :value="query" created v-if="showNewOption">
          </el-option>
          <slot></slot>
        </el-scrollbar>
        <template v-if="emptyText && (!allowCreate || loading || (allowCreate && options.length === 0 ))">
          <slot name="empty" v-if="$slots.empty"></slot>
          <p class="el-select-dropdown__empty" v-else>
            {{ emptyText }}
          </p>
        </template>
      </el-select-menu>
    </transition>
  </div>
</template>
<script>
import { Select } from 'element-ui';
export default {
  name: "CustomSelect",
  mixins: [Select],
  props: {
    otherValue: {
      type: String,
      default: "-1"
    }
  },
  data() {
    return {
      remarkData: "",
    }
  },
  computed: {
  },
  methods: {
    notAnything: function () {
    }
  }
}
</script>
<style lang="less" scoped>
.custom-el-select {
  .custom-disabled {
    padding-left: 13px;
    padding-right: 13px;
    box-sizing: border-box;
    /deep/.el-select .el-tag {
      display: inline;
    }
    /deep/.el-tag.el-tag--info {
      background-color: transparent;
      display: inline;
      border: none;
      font-size: 14px;
      font-family: "SourceHanSansCN";
      color: #000;
      margin: 0;
      padding: 0;
    }
  }
  /deep/ .el-input {
    &.is-focus {
      .el-input__inner {
        border-color: rgba(234, 234, 234, 1);
      }
    }
  }
  .el-select__tags-text {
    .other-remark-box {
      display: flex;
      align-items: center;
      .line {
        margin-left: 5px;
        margin-right: 5px;
      }
      .txt-remark {
        width: 60px;
        background: transparent;
        border: none;
        outline: none;
        font-size: 12px;
        color: #de4154;
        &:focus {
          border: none;
        }

        &::-webkit-input-placeholder {
          color: rgba(236, 64, 64, 0.502);
        }

        &::-moz-placeholder {
          color: rgba(236, 64, 64, 0.502);
        }

        &::-ms-input-placeholder {
          color: rgba(236, 64, 64, 0.502);
        }
      }
    }
  }
  .el-input {
    /deep/.el-input__inner {
      min-height: 46px;
    }
  }
  /deep/.el-tag.el-tag--info {
    background-color: rgba(255, 243, 243, 1);

    border: none;
    color: rgba(236, 64, 64, 1);

    font-size: 14px;
    font-family: "SourceHanSansCN";
  }
  /deep/.el-tag__close {
    background: transparent;
    color: rgba(222, 65, 84, 1);
    &:hover {
      color: rgba(222, 65, 84, 1);
      background: transparent;
    }
  }
  /deep/.el-select .el-tag__close.el-icon-close {
    background-color: #fff;
    top: 0;
    color: #fff;
    flex-shrink: 0;
  }
  /deep/.el-input.is-disabled .el-input__inner {
    background: transparent;
  }
}
.customselect-popper {
  margin-top: 1px;
  /deep/.popper__arrow::after {
    border-bottom-color: transparent;
  }
  /deep/.el-select-dropdown__wrap {
    .el-select-dropdown__item {
      &.selected {
        color: rgba(236, 64, 64, 1);
        &::after {
          content: none;
        }
      }
      &.hover {
        background-color: rgba(255, 243, 245, 1);
      }
    }
  }
  /deep/.el-select-dropdown.is-multiple
    .el-select-dropdown__item.selected::after {
    content: none;
  }
  /deep/.popper__arrow,
  .popper__arrow::after {
    border-style: none !important;
  }
}
</style>
